<object type="image/svg+xml" data="/assets/images/top10-icons.svg" style="display:none;"></object>

<!-- Rate-integrity readback marker. Every value comes from the already validated effective
     payload retained by FruHttpService; no second fetch or parallel source is introduced. -->
<span
  *ngIf="rateProvenance as rate"
  hidden
  data-rate-provenance="effective-revision-v1"
  [attr.data-rate-revision-id]="rate.revision_id"
  [attr.data-rate-revision-sha256]="rate.revision_sha256"
  [attr.data-rate-offer-sha256]="rate.offer_sha256"
  [attr.data-rates-checked-timestamp]="rate.rates_checked_timestamp"
  [attr.data-rate-disclosure-content-sha256]="rate.disclosure.content_sha256"
  [attr.data-rate-disclosure-bundle-sha256]="rate.disclosure.bundle_sha256"
  [attr.data-rate-disclosure-context]="rate.disclosure.context"
></span>

<!-- FRU-21694 (abx seq134 #1104.1): the visible product H1 moved INTO the Hope chrome (chat.component);
     this rates-form node sat behind the full-viewport Hope overlay. Title/meta still set in ngOnInit. -->

<!-- ⚡ FAST progress — green checks as questions auto-resolve (FRU-21170) -->
@if (!showAssistant && !assistantLaunchPending && !hideFastModeChrome && fastMode.enabled && (fastMode.resolved$ | async)?.length) {
  <div class="fast-progress">
    <div class="fast-progress-head"><span class="fast-progress-bolt">⚡</span> FAST is filling these in</div>
    @for (q of (fastMode.resolved$ | async); track q) {
      <div class="fast-progress-item">
        <span class="fast-check">✓</span> <span class="fast-progress-label">{{ q }}</span>
      </div>
    }
  </div>
}

@if (brandService.view === 'fru' && userExiting) {
  <div
    class="motivate-popup"
    (click)="closeExitIntentPopup()"
    >
    <div class="motivate-dialog" [@inFormPopup] (click)="$event.stopPropagation()">
      <img
        class="close-exit-intent-popup"
        src="/assets/images/grey-x.png"
        (click)="closeExitIntentPopup()"
        />
        <div class="motivate-title">
          Leaving Already?
        </div>
        <div class="motivate-text">
          {{ 'You\'re moments away from receiving your ' + (form.controls.formType.value != 'debtsettlement' && this.form.controls.formType.value != 'debtrelief' ? 'rate' : 'options') + ' from the top lenders in your area, FREE!' }}
        </div>
        <div style="text-align: center;">
          <button
            class="motivate-button continue has-shadow-small"
            style="width: 350px;"
            (click)="closeExitIntentPopup()"
            >
          Click to Continue
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      <div class="motivate-logo-container">
        @if (brandService.logoSrc) {
          <img class="motivate-logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}">
        }
      </div>
    </div>
  </div>
}

<!-- <div class="selected-prompt-wraper" *ngIf="showPrompt && promptAllowed">
<div class="selected-prompt">
  <h2 class="title is-size-4-mobile">{{ promptText }}</h2>
  <button class="button continue is-large has-shadow-small" (click)="continueWith('yes')">
    Yes&nbsp;&nbsp;&nbsp;&nbsp;
    <i class="fas fa-chevron-right"></i>
  </button>

  <button class="button continue is-large has-shadow-small" (click)="continueWith('no')">
    No&nbsp;&nbsp;&nbsp;&nbsp;
    <i class="fas fa-chevron-right"></i>
  </button>

  <div style="font-family: Tahoma; font-size: 14px; padding: 4px; margin-top: 40px;">
    We take your privacy seriously. By clicking the button above, You agree that we can share your personal data with third parties, such as our mortgage partners, service providers and other affiliates, and that we can use this data for marketing and analytics, and to make your experience easier. you are also providing your<b>express written consent</b> to have your information shared and to be matched with up to five <a *ngIf="!fruLocalKiosk" href="/approved-lenders" target="_new" rel="nofollow">approved lenders</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">approved lenders</a> and for them, or their authorized third party, to call you at the number you have provided including through automated means such as autodialing, text SMS/MMS (charges may apply), and prerecorded messaging, and/or via email, even if your telephone number is a cellular phone number or on a corporate, state, or the National Do Not Call Registry, and you agree to our Privacy Policy <a *ngIf="!fruLocalKiosk" href="/privacy" target="_new" rel="nofollow">Privacy Policy</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">Privacy Policy</a>. Consent is not required as a condition to utilize FreeRateUpdate's services, you may choose to use our services by calling 855-315-7283. Consent is not contingent on the purchase and/or use of any services being offered by a Lender.
  </div>
</div>
</div> -->

@if (fruLocalKiosk) {
  <app-link-click-modal [isModalActive]="showModal" (closed)="toggleModal()"></app-link-click-modal>
}
@if (!showAssistant && !assistantLaunchPending) {
  <header style="position:sticky;top:0;z-index:1000;">
    <nav [ngClass]="['navbar', 'is-light', brandService.view === 'best' ? 'best' : '', top10FormDesign2025 ? 'top10-form-design-2025' : '', isTop10newFooterForm ? 'top10-new-footer-form' : '', showBrandHeader ? 'brand-header-nav' : '', showAiAssistantSwitch && showPoweredByHeader ? 'lrf-branded-header' : '', showAiAssistantSwitch ? 'fru21526-form-header' : '']">
      <div class="container" data-fru21436-hdr-row style="display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:100%;gap:8px;padding-top:8px;padding-bottom:8px;">

        <div class="navbar-brand" [style.padding]="showBrandHeader ? '0' : null" [style.justify-content]="useLrfBrandedHeader ? 'flex-start' : null" [style.flex]="useLrfBrandedHeader ? '0 0 auto' : null">
          @if (showBrandHeader) {
            <div class="brand-pb" style="margin: 10px 0 6px;" [style.align-items]="useLrfBrandedHeader ? 'flex-start' : null" [style.flex-direction]="useLrfBrandedHeader ? 'column' : null" [style.width]="useLrfBrandedHeader ? 'auto' : null">
              @if (showPoweredByHeader) {
                <span [style.color]="useLrfBrandedHeader ? '#4a4a4a' : null" [style.font-size.px]="useLrfBrandedHeader ? (deviceService.isMobile() ? 10 : 11) : null" [style.text-align]="useLrfBrandedHeader ? 'center' : null" [style.width.px]="useLrfBrandedHeader ? 90 : null">{{ ratesFormHeaderLabel }}</span>
              }
              @if (showPoweredByHeader) {
                <span class="pb-logo" [style.margin-left]="useLrfBrandedHeader ? '0' : null">
                  <span class="pb-text">Powered by</span>
                  <img class="logo" src="/assets/images/freerateupdate-logo.svg" alt="FreeRateUpdate.com" [style.width.px]="useLrfBrandedHeader ? 90 : (deviceService.isMobile() ? 120 : 160)" style="height: auto;">
                </span>
              } @else {
                @if (!recommendedLenderActive) {
                  <img class="logo" src="/assets/images/freerateupdate-logo.svg" alt="FreeRateUpdate.com" [style.width.px]="deviceService.isMobile() ? 120 : 160" style="height: auto;">
                }
              }
            </div>
          } @else {
            <!-- <img class="logo" src="/assets/images/recommended_logo.png" alt="Recommended Lender" *ngIf="recommendedLenderActive"> -->
            @if (brandService.logoSrc && !recommendedLenderActive) {
              <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" [errorSrc]="brandService.logoWasabiSrc">
            }
          }
        </div>

        <!-- FRU-21436: compact LowRateFinder AI Assistant, top-right of the persistent header (every step). -->
        @if (showAiAssistantSwitch && !showAssistant && !(steps && steps[currentStepKey] && steps[currentStepKey].key === 'phone')) {
          <button type="button" (click)="startAiAssistantFromButton()" aria-label="Ask Hope" style="position:relative;overflow:visible;margin-left:auto;margin-top:4px;margin-bottom:4px;align-self:center;display:inline-flex;align-items:center;gap:6px;padding:5px 10px;border:1.5px solid rgba(150,52,238,.42);border-radius:10px;background:#fff;color:#332a47;line-height:1.05;box-shadow:0 4px 14px rgba(150,52,238,.20);-webkit-tap-highlight-color:transparent;cursor:pointer;text-align:left"><span style="font-size:.8rem;font-weight:800;letter-spacing:.1px;white-space:nowrap">Ask <span style="color:#9634ee">Hope</span></span><svg width="20" height="18" viewBox="0 0 46 42" aria-hidden="true" style="flex:0 0 auto;display:block"><path d="M14 7c1.2 8.4 5.5 12.7 14 14-8.5 1.3-12.8 5.6-14 14C12.8 26.6 8.5 22.3 0 21c8.5-1.3 12.8-5.6 14-14z" fill="#9634ee"/><path d="M31 0c.7 5 3.2 7.5 8.2 8.2-5 .8-7.5 3.3-8.2 8.3-.8-5-3.3-7.5-8.3-8.3C27.7 7.5 30.2 5 31 0z" fill="#52a9ff"/><path d="M35 25c.8 5.2 3.4 7.8 8.6 8.6-5.2.8-7.8 3.4-8.6 8.4-.8-5-3.4-7.6-8.4-8.4 5-.8 7.6-3.4 8.4-8.6z" fill="#9634ee"/></svg></button>
        }
        @if (showAssistant) {
          <span aria-hidden="true" style="position:relative;overflow:visible;margin-left:auto;margin-top:4px;margin-bottom:4px;align-self:center;display:inline-flex;align-items:center;gap:6px;padding:5px 10px;border:1.5px solid rgba(150,52,238,.42);border-radius:10px;background:#fff;color:#332a47;line-height:1.05;box-shadow:0 4px 14px rgba(150,52,238,.20);-webkit-tap-highlight-color:transparent;pointer-events:none"><span style="font-size:.8rem;font-weight:800;letter-spacing:.1px;white-space:nowrap">Ask <span style="color:#9634ee">Hope</span></span><svg width="20" height="18" viewBox="0 0 46 42" aria-hidden="true" style="flex:0 0 auto;display:block"><path d="M14 7c1.2 8.4 5.5 12.7 14 14-8.5 1.3-12.8 5.6-14 14C12.8 26.6 8.5 22.3 0 21c8.5-1.3 12.8-5.6 14-14z" fill="#9634ee"/><path d="M31 0c.7 5 3.2 7.5 8.2 8.2-5 .8-7.5 3.3-8.2 8.3-.8-5-3.3-7.5-8.3-8.3C27.7 7.5 30.2 5 31 0z" fill="#52a9ff"/><path d="M35 25c.8 5.2 3.4 7.8 8.6 8.6-5.2.8-7.8 3.4-8.6 8.4-.8-5-3.4-7.6-8.4-8.4 5-.8 7.6-3.4 8.4-8.6z" fill="#9634ee"/></svg></span>
        }

        <!-- FRU-21526: on the submit(phone) step the Ask Hope pill is hidden, so show the Secure
             badge here in the header top-right (like the AI form), never overlapping the card heading. -->
        @if (showAiAssistantSwitch && !showAssistant && steps && steps[currentStepKey] && steps[currentStepKey].key === 'phone') {
          <span class="fru21526-header-secure" aria-hidden="true"><i class="fa fa-lock"></i> Secure</span>
        }
        @if (officeStatus && officeStatus.answer && !fruLocal && !isTopTenBestLenders) {
          <div class="navbar-end" [class.hide-on-mobile-phone-step]="steps && steps[currentStepKey] && steps[currentStepKey].key === 'phone'" [class.call-card-keyboard-open]="keyboardOpen">
            <p class="has-text-grey-dark is-size-6">or call for rates...</p>
            <p class="is-size-4 has-text-weight-semibold">
              <a href="tel:{{officeStatus.phone}}" target="_blank" (click)="phoneClicked()">
                <i class="fas fa-phone"></i>
                {{ officeStatus.phonefancy }}
              </a>
              @if (chatButtonTestStatus) {
                <span class="experiment_chat_wrapper">
                  <i role="button" class="fas fa-comment experiment_chat_button"></i>
                  Chat
                </span>
              }
            </p>
          </div>
        }
      </div>
    </nav>
  </header>
}

@if (assistantLoadFailed && !showAssistant && !assistantLaunchPending) {
  <div class="assistant-load-fallback" role="alert" aria-live="assertive">
    <strong>Hope couldn&rsquo;t open.</strong> Your answers are safe. Continue below.
  </div>
}

<!-- FRU-21436: in-place LowRateFinder assistant flip. Full-viewport overlay covering ALL form chrome. -->
@if (showAssistant) {
  <section id="ai-assistant-host"
    [class.hope-samsung-internet]="hopeSamsungInternet"
    style="position:fixed;inset:0;z-index:1000;display:block;background:#d7e2d8;overflow-y:auto;overflow-x:hidden">
    <!-- Ed 7/8: the viewport wrapper keeps header+chat at exactly 100dvh; the footer lives BELOW the
         fold (scroll to see it) so it can never shrink the chat / push the message box higher. -->
    <div class="ai-body-content">
      <div class="hope-ai-viewport" style="height:100dvh;display:flex;flex-direction:column;min-height:0">
        <!-- FRU-21436: SAME header as landing/form so it feels like one continuous site across the flip. -->
        <header style="flex:0 0 auto;position:relative;z-index:1010">
          <nav [ngClass]="['navbar', 'is-light', brandService.view === 'best' ? 'best' : '', top10FormDesign2025 ? 'top10-form-design-2025' : '', isTop10newFooterForm ? 'top10-new-footer-form' : '', showBrandHeader ? 'brand-header-nav' : '', showPoweredByHeader ? 'lrf-branded-header' : '']">
            <div class="container" style="display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:100%;gap:8px;padding-top:8px;padding-bottom:8px;">
              <div class="navbar-brand" [style.padding]="showBrandHeader ? '0' : null" [style.justify-content]="useLrfBrandedHeader ? 'flex-start' : null" [style.flex]="useLrfBrandedHeader ? '0 0 auto' : null">
                @if (showBrandHeader) {
                  <div class="brand-pb" style="margin: 10px 0 6px;" [style.align-items]="useLrfBrandedHeader ? 'flex-start' : null" [style.flex-direction]="useLrfBrandedHeader ? 'column' : null" [style.width]="useLrfBrandedHeader ? 'auto' : null">
                    @if (showPoweredByHeader) {
                      <span [style.color]="useLrfBrandedHeader ? '#4a4a4a' : null" [style.font-size.px]="useLrfBrandedHeader ? (deviceService.isMobile() ? 10 : 11) : null" [style.text-align]="useLrfBrandedHeader ? 'center' : null" [style.width.px]="useLrfBrandedHeader ? 90 : null">{{ ratesFormHeaderLabel }}</span>
                    }
                    @if (showPoweredByHeader) {
                      <span class="pb-logo" [style.margin-left]="useLrfBrandedHeader ? '0' : null">
                        <span class="pb-text">Powered by</span>
                        <img class="logo" src="/assets/images/freerateupdate-logo.svg" alt="FreeRateUpdate.com" [style.width.px]="useLrfBrandedHeader ? 90 : (deviceService.isMobile() ? 120 : 160)" style="height: auto;">
                      </span>
                    } @else {
                      <img class="logo" src="/assets/images/freerateupdate-logo.svg" alt="FreeRateUpdate.com" [style.width.px]="deviceService.isMobile() ? 120 : 160" style="height:auto;">
                    }
                  </div>
                } @else {
                  @if (brandService.logoSrc) {
                    <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" [errorSrc]="brandService.logoWasabiSrc">
                  } @else {
                    <img class="logo" src="/assets/images/freerateupdate-logo.svg" alt="FreeRateUpdate.com" [style.width.px]="deviceService.isMobile() ? 120 : 160" style="height:auto;">
                  }
                }
              </div>
              <!-- Ed 7/14: the Secure trust mark moved OUT of the chat card (it was an absolute overlay the
                   content had to dodge) to the header's free top-right — gold lock on the page gradient. -->
              <span class="hope-header-right">
                <!-- FRU-23970 (Ed, 10/7 9:33 to 9:35 AM: "it doesn't make any sense at the top"): Ask Hope and the call number moved to a
                     small dock at the bottom right of Hope's own bar (chat component). -->
                <span class="hope-secure-header"><svg width="13" height="15" viewBox="0 0 448 512" aria-hidden="true" focusable="false"><path fill="#f5b914" d="M144 144v48h160v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192v-48C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64h16z"/></svg> Secure</span>
                <!-- FRU-23412 (Ed, 9/29 12:24 PM): no phone number in the Hope Direct header. The original form's header keeps its own. -->
              </span>
              <!-- FRU-21526 V6 (Ed 7/11): removed the 'Continue without AI' escape hatch (it hurt conversion — visitors bailed out of the Hope arm). -->
            </div>
          </nav>
        </header>
        <!-- FRU-21436: chat is created here at runtime from a lazy-loaded module (separate async chunk). -->
        <ng-container #assistantHost style="flex:1 1 auto;overflow:auto"></ng-container>
      </div>
      <!-- Ed 7/16 (design lock #3): Advertising Disclosure below the chat box, bottom right. Lives OUTSIDE
           the 100dvh viewport (abx 320 HOLD: inside it, the strip stole ~24px of chat height and pushed the
           action row under the bar at 320x568). Mobile: just below the fold with the footer; desktop: visible. -->
      <!-- Ed 8/7: the rates-checked stamp lives HERE (small, centered) -- out of the opening bubble,
           above the disclosure it substantiates. -->
      @if (rateFreshness.display$ | async; as rcText) {
        <div class="hope-rates-checked">{{ rcText }}</div>
      }
      <div class="hope-ad-disclosure"><button type="button" (click)="adDisclosurePopup()">* Advertising Disclosure</button></div>
    </div>
    <!-- Hope desktop footer stack: artwork is intentionally inside the compliance footer so the art
         and legal links move as one footer unit. .hope-footer-links owns the compact legal padding;
         .hope-footer-art owns only the decorative image strip. -->
    <footer class="hope-ai-footer" aria-label="Site links and licensing">
      <!-- Legal links stay grouped separately from the artwork so padding changes do not resize the image. -->
      <div class="hope-footer-art"></div>
      <div class="hope-footer-links">
        <p class="hai-owned">This website is owned and operated by FreeRateUpdate.com LLC.</p>
        <p class="hai-links">
          NMLS <a href="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1154338" target="_blank" rel="noopener">#1154338</a> &middot;
          <a href="/contact" target="_blank">Contact</a> &middot;
          <a href="/privacy" rel="nofollow" target="_blank">Privacy</a> &middot;
          <a href="/glba" rel="nofollow" target="_blank">GLBA</a> &middot;
          <a href="/cpra_policy" rel="nofollow" target="_blank">CPRA</a> &middot;
          <a href="/terms" rel="nofollow" target="_blank">Terms</a> &middot;
          <a href="/licensing_disclosure" rel="nofollow" target="_blank">Licensing Disclosure</a> &middot;
          <a [href]="adDisclosureHref()" target="_blank" rel="noopener" (click)="adDisclosureClick($event)" style="white-space: nowrap;">* Advertising Disclosure</a> &middot;
          <a class="not-sell" href="/your_privacy_choices">Preferences</a>
        </p>
      </div>
      <!-- Ed 8/9 2:26 AM: the visible build stamp is retired from the consumer footer. The tag is
           still resolvable for debugging via the deployed bundle hashes / DeployHQ. -->
    </footer>
  </section>
}

@if (!showAssistant && !assistantLaunchPending) {
  <section id="rates-form"
    [ngClass]="[
      'section',
      isSrcExitPopup ? 'src-exit-popup' : '',
      brandService.view === 'best' ? 'best' : '',
      top10FormDesign2025 ? 'top10-form-design-2025' : '',
      isTop10newFooterForm ? 'top10-new-footer-form' : '',
      brandService.view !== 'best' && !fruLocalKiosk ? 'rates-form-bottom-room' : '',
      showAiAssistantSwitch ? 'fru21526-rates-form' : '',
      onPropertyTypeStep ? 'property-type-step' : '',
    ]"
    [ngStyle]="{ 'padding-top' : fruLocalKiosk ? '4.5rem' : '0.85rem'}"
    >
    <div class="container" [ngStyle]="{'position': showModal ? 'sticky' : 'relative'}">

      <form id="mainForm" name="mainForm" class="has-text-centered app-step-form-border-radius"
      [ngClass]="{
        'fixed_height': fruLocalKiosk,
        'bg-hidden': isSubmitting,
        'fast-mode-variation': isFastModeAllowed,
        'full-fast-flow-test': isFullFastFlow,
      }"
        [style]="'background: transparent;'"
        [formGroup]="form" (keydown.enter)="$event.preventDefault()">

        @if (currentStepKey > 0 && !hideFastModeChrome) {
          <button type="button" class="rates-form-back-button" (click)="goBack()" aria-label="Go back" style="position:absolute;left:18px;top:14px;z-index:5;border:0;background:transparent;width:42px;height:42px;padding:0;cursor:pointer;opacity:.72">
            <span aria-hidden="true" style="display:block;width:18px;height:18px;margin:12px 0 0 12px;border-left:4px solid #777;border-bottom:4px solid #777;transform:rotate(45deg);border-radius:2px"></span>
          </button>
        }

        <!-- ⚡ Persistent FAST toggle on every step (FRU-21170) -->
        @if (isFastModeAllowed && !isSubmitting && !(isFullFastFlow && isFastModePhoneStep)) {
          <div class="fast-stepbar" [class.is-on]="fastMode.enabled">
            <div class="fast-stepbar-text">
              <span class="fast-stepbar-title"><span class="fast-stepbar-bolt">⚡</span> FAST</span>
              <span class="fast-stepbar-sub">{{ fastMode.enabled ? "On — tap to take the wheel" : "Fills answers instantly. Tap to enable." }}</span>
            </div>
            <button type="button" class="fast-stepbar-switch" (click)="toggleFast()" aria-label="Toggle fast mode" [attr.aria-pressed]="fastMode.enabled">
              <span class="fast-switch-bolt">⚡</span>
              <span class="fast-switch-state">{{ fastMode.enabled ? "ON" : "OFF" }}</span>
              <span class="fast-switch-knob"></span>
            </button>
          </div>
        }

        @for (step of steps; track step) {
          <app-step
            class="app-step app-step-floating-card {{step.key}}"
            [ngStyle]="{'margin-top': currentStepKey > 0 ?'7%':'5%', 'background': '#fff'}"
            [type]="step.component"
            (stepEvent)="nextStep()"
            [@stepState]="step.state"
            [selectedLenders] = "availableSelected$ | async"
            [isSelectedLeads] = "isSelectedLeads$ | async"
            [isUncheckedTest] = "isUncheckedTest$ | async"
            [isBeEnabled] = "isBeEnabled$ | async"
            (@stepState.done)="stepAnimationDone()">
          </app-step>
        }
        <input type="hidden" name="universal_leadid" id="leadid_token" autocomplete="off" value="">
      </form>
    </div>

    @if (!top10FormDesign2025 && !isSrcExitPopup && !isTop10newFooterForm && (brandService.view === 'best' || fruLocalKiosk)) {
      <footer [ngClass]="brandService.view === 'best' ? 'best' : ''" id="rates-form-footer"
        [ngStyle]="{'padding-bottom': leadDisclosure ?'10vh':'20vh'}"
        >
        <div class="container">
          @if (!isSecureForm) {
            <div class="columns is-mobile app-step-footer-border-radius">
              <div class="column is-two-thirds">
                <div class="align-badges">
                  <div>
                    <img src="/assets/images/data-privacy.png" class="secure_form_img">
                  </div>
                  @if (!isTopTenBestLenders) {
                    <div class="bbb-image">
                      <img src="/assets/images/bbb-a-plus-rating.gif" alt="Better Business Bureau A+ Rated" width="80">
                    </div>
                  }
                </div>
              </div>
              @if (brandService.view !== 'best') {
                <div class="column is-one-third has-text-right">
                  @if (!fruLocalKiosk) {
                    <a [href]="adDisclosureHref()" target="_blank" rel="noopener" (click)="adDisclosureClick($event)" style="white-space: nowrap;">
                      * Advertising Disclosure
                    </a>
                  }
                </div>
              }
            </div>
          }
          <!-- fruLocalKiosk  -->
          @if (fruLocalKiosk && !showModal) {
            <div class="start-over">
              <p class="is-size-4 has-text-weight-semibold">
                <a (click)="redirectToStartOver()">
                  <i class="fas fa-rotate-left"></i>
                  Start over
                </a>
              </p>
            </div>
          }
        </div>
      </footer>
    }

  </section>
}

@if (!showAssistant && !assistantLaunchPending && ((brandService.view !== 'best' && !fruLocalKiosk) || isSrcExitPopup)) {
  <footer class="footer">
    <div class="footer-art"></div>
    <div class="footer-content">
      <div class="container">
        <p>This website is owned and operated by FreeRateUpdate.com LLC.</p>
        <p>
          <a href="/contact" target="_blank">Contact</a> &middot;
          <a href="/privacy" rel="nofollow" target="_blank">Privacy</a> &middot;
          <a href="/glba" rel="nofollow" target="_blank">GLBA</a> &middot;
          <a href="/cpra_policy" rel="nofollow" target="_blank">CPRA</a> &middot;
          <a href="/terms" rel="nofollow" target="_blank">Terms</a> &middot;
          <a href="/licensing_disclosure" rel="nofollow" target="_blank">Licensing Disclosure</a> &middot;
          @if (!fruLocalKiosk) {
            <a [href]="adDisclosureHref()" target="_blank" rel="noopener" (click)="adDisclosureClick($event)" style="white-space: nowrap;">* Advertising Disclosure</a>
          } &middot;
          <a class="not-sell" href="/your_privacy_choices">Preferences</a> &middot;
          <a href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/1154338" target="_blank">NMLS #1154338</a>
        </p>
      </div>
    </div>
  </footer>
}

@if (!showAssistant && !assistantLaunchPending && fruLocalKiosk && !isSrcExitPopup) {
  <footer class="footer is-size-7" style="padding-bottom: 1rem;">
    <div class="container">
      <p style="margin-top: 1rem;text-align: center;">FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with a network of participating lenders and brokers that compensate it for advertising and marketing services. It is not a lender and does not make loans. Its main office is located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. © FreeRateUpdate.com LLC 2008 - {{ currentYear }}. All Rights Reserved.
        <a (click)="toggleModal()">Privacy Policy</a> | <a (click)="toggleModal()">* Advertising and Licensing Disclosures</a></p>
    </div>
  </footer>
}

@if (!showAssistant && !assistantLaunchPending && brandService.view === 'best' && !fruLocalKiosk && !isSrcExitPopup) {
  <footer
    [ngClass]="{
      'footer': true,
      'is-size-7': true,
      'has-text-centered-touch': true,
      'ab-secure': isSecureForm,
      'top10-form-design-2025': top10FormDesign2025,
      'top10-new-footer-form': isTop10newFooterForm
    }"
    >
    @if (isTop10newFooterForm) {
      <div class="footer-top10-art"></div>
    }
    @if (!isTop10newFooterForm) {
      <nav class="navbar is-light">
        <div class="container">
          <div class="navbar-brand is-block-touch">
            <p>
              <!--
              <img class="logo" src="/assets/images/recommended_logo.png" alt="Recommended Lender" *ngIf="recommendedLenderActive">
              <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc && !recommendedLenderActive" [errorSrc]="brandService.logoWasabiSrc">
              -->
            </p>
          </div>
          <div class="navbar-end">
            @if (!isSecureForm) {
              <a class="navbar-item has-text-grey-light" href="/contact" target="_blank">
                Contact Us
              </a>
            }
            <a class="navbar-item has-text-grey-light" href="/privacy" target="_blank">
              Privacy@if (!isSecureForm) {
              <span> Policy</span>
            }
          </a>
          <a class="navbar-item has-text-grey-light" href="/glba" target="_blank">
            GLBA Policy
          </a>
          <a class="navbar-item has-text-grey-light" href="/cpra_policy" target="_blank">
            CPRA Policy
          </a>
          <a class="navbar-item has-text-grey-light" href="/terms" target="_blank">
            General@if (!isSecureForm) {
            <span> Terms</span>
          }
        </a>
        <a class="navbar-item has-text-grey-light" href="/licensing_disclosure" target="_blank">
          Licensing Disclosure
        </a>
        <a class="navbar-item has-text-grey-light" href="/your_privacy_choices" target="_blank">
          Privacy Preferences
        </a>
      </div>
    </div>
  </nav>
    }
    @if (!isSecureForm) {
      <div class="container">
        <div class="copyright">
          <div class="columns">
            <div class="column flex-end">
              {{ currentYear }} &copy; All Rights Reserved
            </div>
            @if (!isTopTenBestLenders) {
              <div class="column poweredby">
                <img class="logo" src="/images/logo-medium.png">
                <br>
                  Powered by FreeRateUpdate
                </div>
              }
              @if (!isTopTenBestLenders) {
                <div class="column has-text-right-desktop has-text-centered flex-end-right">
                  2 Ponds Edge Drive, Chadds Ford, PA 19317
                </div>
              }
            </div>
            @if (!isTopTenBestLenders) {
              <p class="mt-5">
                FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with a network of participating lenders and brokers that compensate it for advertising and marketing services. It is not a lender and does not make loans. Its main office is located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. &copy; FreeRateUpdate.com LLC 2008 - {{ currentYear }}. All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.
              </p>
            }
            @if (isTopTenBestLenders) {
              <div class="is-size-7 disclosure" style="margin: 10px auto;">
                <p class="first">Top10bestlenders.com is a Marketing Lead Generator, as defined in the General Terms, and is compensated by Lenders for the services provided. Top10bestlenders.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 440 Peoples Plaza, Newark, DE 19702. NMLS Unique Identifier #2620807. NMLS Consumer Access - <a href="https://nmlsconsumeraccess.org" target="_blank">nmlsconsumeraccess.org</a> &copy; Top10bestlenders.com LLC 2019 - {{ currentYear }}. Top10bestlenders.com Corp is Licensed Mortgage Originator as required by law. All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.</p>
                <p class="first">LEAD GENERATOR ONLY, NOT ACTING IN THE CAPACITY OF A MORTGAGE LOAN ORIGINATOR, MORTGAGE BROKER, MORTGAGE CORRESPONDENT LENDER OR MORTGAGE LENDER. INFORMATION RECEIVED WILL BE SHARED WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR RESIDENTIAL MORTGAGE LOAN INQUIRY</p>
                <p class="first"> CT: <strong>MORTGAGE BROKER ONLY</strong>, NOT A MORTGAGE LENDER OR MORTGAGE CORRESPONDENT LENDER.</p>
                <h6>Advertising Disclosure</h6>
                <p class="second">This site acts as a free online resource that tries to offer helpful content and comparison features to our visitors. We accept advertising compensation from companies that appear on the site. Company listings on this page DO NOT imply endorsement. We do not feature all providers on the market. Except as expressly set forth in our <a href="/terms" target="_blank">Terms of Use</a>, all representations and warranties regarding the information presented on this page are disclaimed. The information, including pricing, which appears on this site is subject to change at any time. Placement on the site could be impacted by compensation.</p>
              </div>
            }
          </div>
        </div>
      }
      @if (isTop10newFooterForm) {
        <nav class="footer-bot-nav" aria-label="Footer navigation">
          <p>
            <a target="_blank" rel="noopener noreferrer" href="/contact">Contact</a> &middot;
            <a target="_blank" rel="noopener noreferrer" href="/privacy">Privacy</a> &middot;
            <a target="_blank" rel="noopener noreferrer" href="/glba">GLBA</a> &middot;
            <a target="_blank" rel="noopener noreferrer" href="/cpra_policy">CPRA</a> &middot;
            <a target="_blank" rel="noopener noreferrer" href="/terms">Terms</a> &middot;
            <a target="_blank" rel="noopener noreferrer" href="/licensing_disclosure">Licensing Disclosure</a> &middot;
            <a target="_blank" rel="noopener noreferrer" href="/your_privacy_choices">Preferences</a> &middot;
          </p>
        </nav>
      }
    </footer>
  }

  @if (debug) {
    <section class="section" id="dev-debug">
      <pre>{{form.value | json}}</pre>
    </section>
  }

  <div id="form-modal" class="modal">
    <div class="modal-background"></div>
  </div>

  @if (isSubmitting) {
    <div id="loadSpinner">
      <h3>Hang tight. We're finding additional lenders and gathering information plus website links.</h3>
      <h4>This will only take a moment.</h4>
      <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  }
